import { SVGProps } from "react";

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={props.width || "24"}
        height={props.height || "24"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6 5H14C14.55 5 15 5.45 15 6V10C15 10.55 14.55 11 14 11H10.5L8 13.5V11H6C5.45 11 5 10.55 5 10V6C5 5.45 5.45 5 6 5Z"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <line
            x1="6.5"
            y1="6.9"
            x2="13.5"
            y2="6.9"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
        />
        <line
            x1="6.5"
            y1="8.4"
            x2="12.5"
            y2="8.4"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
        />
        <line
            x1="6.5"
            y1="9.9"
            x2="10.5"
            y2="9.9"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
        />
    </svg>
);
